import Vue from 'vue'
import Vuex from 'vuex'
import { mapMutations } from 'vuex'
import axios from "axios";
import VueAxios from "vue-axios";
Vue.use(Vuex, VueAxios, axios);

// デフォルト設定
const defaultParams = {
    requestDomain: "",
    careInsuranceCardImageFrontOnChange: false,
    careInsuranceCardImageBackOnChange: false
};

// PHRシステム連携
const phrSystemLink = {
    phrUserId: '',
}
// PHRシステム
const phrSystem = {
    phrAlias: ''
}

// 申請データ
const consentApplicant = {

    lastName: '',
    firstName: '',
    maidenName: '',
    lastNameKana: '',
    firstNameKana: '',
    maidenNameKana: '',

    gender: '',
    birthDateStr: '',
    postcodeNumStr: '',
    prefectureStr: '',
    city: '',
    town: '',
    lotNumber: '',
    detailAddress: '',

    telNumber: '',
    mobileNumber: '',
    emailAddress: '',

    insuredCheck: true,
    insuredPersonSymbol: '',
    insuredPersonNumber: '',
    insuredPersonBranchNumber: '',
    insurerNumber: '',

    careInsuredCheck: false,
    careDescribedInsurerNumber: '',
    careInsuredPersonNumber: '',

    wdAraLnkConsentFlagBool: false,
    anonymizeFlagBool: false,
    inclusiveConsFlagBool: false,

    applicantNotices: '',

    // 添付ファイルID
    insuranceCardImageFrontId: '',
    insuranceCardImageBackId: '',
    careInsuCardImageFrontId: '',
    careInsuCardImageBackId: '',

    // 受付番号（メールから遷移してきたとき送信する）
    orderNumber :'',
};

//受付番号
const orderNumber = '';

//バージョン
const version = '';

// 同意状態
const displayName = {};
const explanation = "";
//管理者コメント
const adminComment = "";
const withcomments = "";

// 画面制御関連
const isShowNextBtn = true;
const isApplied = false;
const isInitialized = false;

const symbolToggle=false;
const numberToggle=false;

// 保険証画像データ(健康保険証（表裏）介護保険証（表裏）)
const images = {};

// EHRシステム
const ehrSystem = {

    ehrSystemName: "",
    logoImagePath: "",
    rulePath: "",
    wdAraLnkDisplayName: "",
    wdAraLnkExplanation: "",
    anonymizeDisplayName: "",
    anonymizeExplanation: "",
    inputFieldExplanation:"",
    ruleExplanation:""

};

export default new Vuex.Store({
    // name: "Store",
    strict: true,
    
    state: {
        defaultParams: defaultParams,
        phrSystemLink: phrSystemLink,
        consentApplicant: consentApplicant,
        phrSystem: phrSystem,
        ehrSystem: ehrSystem,
        orderNumber: orderNumber,
        displayName: displayName,
        explanation: explanation,
        adminComment: adminComment,
        withcomments: withcomments,
        isShowNextBtn: isShowNextBtn,
        isApplied: isApplied,
        isInitialized: isInitialized,
        symbolToggle: symbolToggle,
        numberToggle: numberToggle,
        images: images,
        version: version
    },
    methods: {
        ...mapMutations([
            'ehrSystem', // `this.ehrSystem()` を `this.$store.commit('ehrSystem')` にマッピングする
            'explanation',
            'adminComment',
            'isShowNextBtn',
        ]),
        isPhr: function () {
            const phrAlias = this.state.phrSystem.phrAlias;
            const phrUserId = this.state.phrSystemLink.phrUserId;
            if (!phrAlias && !phrUserId) {
                return true;
            }
            return false;
        },

    },
    mutations: {
        // パラメータ（システム情報）
        setDefaultParams(state, defaultParams) {
            state.defaultParams = defaultParams
        },
        // PHRシステム連携
        setPhrSystemLink(state, phrSystemLink) {
            state.phrSystemLink = phrSystemLink
        },
        // PHRシステム
        setPhrSystem(state, phrSystem) {
            state.phrSystem = phrSystem
        },
        //受付番号
        setOrderNumber(state, orderNumber) {
            state.orderNumber = orderNumber
        },

        // 同意申請
        setConsentApplicant(state, consentApplicant) {
            state.consentApplicant = consentApplicant
        },
        //受付番号(メールのURL引数)
        setArgOrderNumber(state, argOrderNumber) {
            state.consentApplicant.orderNumber = argOrderNumber
        },
        setLastName(state, lastName) {
            state.consentApplicant.lastName = lastName
        },
        setFirstName(state, firstName) {
            state.consentApplicant.firstName = firstName
        },
        setMaidenName(state, maidenName) {
            state.consentApplicant.maidenName = maidenName
        },
        setLastNameKanaStr(state, lastNameKanaStr) {
            state.consentApplicant.lastNameKanaStr = lastNameKanaStr
        },
        setFirstNameKanaStr(state, firstNameKanaStr) {
            state.consentApplicant.firstNameKanaStr = firstNameKanaStr
        },
        setMaidenNameKanaStr(state, maidenNameKanaStr) {
            state.consentApplicant.maidenNameKanaStr = maidenNameKanaStr
        },
        setGender(state, gender) {
            state.consentApplicant.gender = gender
        },
        setBirthDateStr(state, birthDateStr) {
            state.consentApplicant.birthDateStr = birthDateStr
        },
        setPostcodeNumStr(state, postcodeNumStr) {
            state.consentApplicant.postcodeNumStr = postcodeNumStr
        },
        setPrefectureStr(state, prefectureStr) {
            state.consentApplicant.prefectureStr = prefectureStr
        },
        setCity(state, city) {
            state.consentApplicant.city = city
        },
        setTown(state, town) {
            state.consentApplicant.town = town
        },
        setLotNumber(state, lotNumber) {
            state.consentApplicant.lotNumber = lotNumber
        },
        setDetailAddress(state, detailAddress) {
            state.consentApplicant.detailAddress = detailAddress
        },
        setTelNumber(state, telNumber) {
            state.consentApplicant.telNumber = telNumber
        },
        setMobileNumber(state, mobileNumber) {
            state.consentApplicant.mobileNumber = mobileNumber
        },
        setEmailAddress(state, emailAddress) {
            state.consentApplicant.emailAddress = emailAddress
        },
        //保険証
        setInsuredCheck(state, insuredCheck) {
            state.consentApplicant.insuredCheck = insuredCheck
        },
        setSymbolToggle(state, symbolToggle) {
            state.symbolToggle = symbolToggle
        },
        setInsuredPersonSymbolStr(state, insuredPersonSymbolStr) {
            state.consentApplicant.insuredPersonSymbolStr = insuredPersonSymbolStr
        },
        setNumberToggle(state, numberToggle) {
            state.numberToggle = numberToggle
        },
        setInsuredPersonNumberStr(state, insuredPersonNumberStr) {
            state.consentApplicant.insuredPersonNumberStr = insuredPersonNumberStr
        },
        setInsuredPersonBranchNumber(state, insuredPersonBranchNumber) {
            state.consentApplicant.insuredPersonBranchNumber = insuredPersonBranchNumber
        },
        setInsurerNumber(state, insurerNumber) {
            state.consentApplicant.insurerNumber = insurerNumber
        },
        // 添付ファイルID（健康保険証・表）
        setInsuranceCardImageFrontId(state, insuranceCardImageFrontId) {
            state.consentApplicant.insuranceCardImageFrontId = insuranceCardImageFrontId
        },
        // ファイル選択変更フラグ（健康保険証・表）
        setInsuranceCardImageFrontOnChanged(state, insuranceCardImageFrontOnChanged) {
            state.images.insuranceCardImageFrontOnChanged = insuranceCardImageFrontOnChanged
        },
        // ファイルイメージ（健康保険証・表）
        setInsuranceCardImageFrontImage(state, insuranceCardImageFrontImage) {
            state.images.insuranceCardImageFrontImage = insuranceCardImageFrontImage
        },
        // 添付ファイルID（健康保険証・裏）
        setInsuranceCardImageBackId(state, insuranceCardImageBackId) {
            state.consentApplicant.insuranceCardImageBackId = insuranceCardImageBackId
        },
        // ファイル選択変更フラグ（健康保険証・裏）
        setInsuranceCardImageBackOnChanged(state, insuranceCardImageBackOnChanged) {
            state.images.insuranceCardImageBackOnChanged = insuranceCardImageBackOnChanged
        },
        // ファイルイメージ（健康保険証・裏）
        setInsuranceCardImageBackImage(state, insuranceCardImageBackImage) {
            state.images.insuranceCardImageBackImage = insuranceCardImageBackImage
        },
        // 介護保険証(添付する)
        setCareInsuredCheck(state, careInsuredCheck) {
            state.consentApplicant.careInsuredCheck = careInsuredCheck
        },
        setCareDescribedInsurerNumber(state, careDescribedInsurerNumber) {
            state.consentApplicant.careDescribedInsurerNumber = careDescribedInsurerNumber
        },
        setCareInsuredPersonNumber(state, careInsuredPersonNumber) {
            state.consentApplicant.careInsuredPersonNumber = careInsuredPersonNumber
        },
        // 添付ファイルID（介護保険証・表）
        setCareInsuCardImageFrontId(state, careInsuCardImageFrontId) {
            state.consentApplicant.careInsuCardImageFrontId = careInsuCardImageFrontId
        },
        // ファイル選択変更フラグ（介護保険証・表）
        setCareInsuranceCardImageFrontOnChanged(state, careInsuranceCardImageFrontOnChanged) {
            state.images.careInsuranceCardImageFrontOnChanged = careInsuranceCardImageFrontOnChanged
        },
        // ファイルイメージ（介護保険証・表）
        setCareInsuranceCardImageFrontImage(state, careInsuranceCardImageFrontImage) {
            state.images.careInsuranceCardImageFrontImage = careInsuranceCardImageFrontImage
        },
        // 添付ファイルID（介護保険証・裏）
        setCareInsuCardImageBackId(state, careInsuCardImageBackId) {
            state.consentApplicant.careInsuCardImageBackId = careInsuCardImageBackId
        },
        // ファイル選択変更フラグ（介護保険証・裏）
        setCareInsuranceCardImageBackOnChanged(state, careInsureddBackOnChanged) {
            state.images.careInsuranceCardImageBackOnChanged = careInsureddBackOnChanged
        },
        // ファイルイメージ（介護保険証・裏）
        setCareInsuranceCardImageBackImage(state, careInsuranceCardImageBackImage) {
            state.images.careInsuranceCardImageBackImage = careInsuranceCardImageBackImage
        },
        // 広域連携フラグ
        setWdAraLnkConsentFlagBool(state, wdAraLnkConsentFlagBool) {
            state.consentApplicant.wdAraLnkConsentFlagBool = wdAraLnkConsentFlagBool
        },
        // ２次利用フラグ
        setAnonymizeFlagBool(state, anonymizeFlagBool) {
            state.consentApplicant.anonymizeFlagBool = anonymizeFlagBool
        },
        // 包括同意フラグ
        setInclusiveConsFlagBool(state, inclusiveConsFlagBool) {
            state.consentApplicant.inclusiveConsFlagBool = inclusiveConsFlagBool
        },
        setApplicantNotices(state, applicantNotices) {
            state.consentApplicant.applicantNotices = applicantNotices
        },
        // EHRシステム
        setEhrSystem(state, ehrSystem) {
            state.ehrSystem = ehrSystem
        },
        // 同意状況取得
        setDisplayName(state, displayName) {
            state.displayName = displayName
        },
        // 状況メッセージ取得
        setExplanation(state, explanation) {
            state.explanation = explanation
        },
        // 管理者コメント取得
        setAdminComment(state, adminComment) {
            state.adminComment = adminComment
        },
        setWithcomments(state, withcomments) {
            state.withcomments = withcomments
        },
        // 「参加する」ボタンの表示（true:表示 false:非表示）
        setIsShowNextBtn(state, isShowNextBtn) {
            state.isShowNextBtn = isShowNextBtn
        },
        // 申請済みの状態（true:申請済み false:未申請）
        setIsApplied(state, isApplied) {
            state.isApplied = isApplied
        },
        // TOP画面の初期化状態（true:初期化済み false:未初期化）
        setIsInitialized(state, isInitialized) {
            state.isInitialized = isInitialized
        },
        // アプリケーションバージョン
        setVersion(state, version) {
            state.version = version
        },
        setRequestDomain(state, requestDomain) {
            state.defaultParams.requestDomain = requestDomain
        },
    },

    actions: {

        // 参加状況取得(stateは永続化した値、criteriaは一時パラメータ)
        // eslint-disable-next-line no-unused-vars
        async getConsentStatus({ commit, state }, criteria) {
            const phrAlias = criteria.phrAlias;
            const phrUserId =  criteria.phrUserId;
            const orderNumber =  criteria.orderNumber;
            const requestDomain = process.env.VUE_APP_API_BASE_URL;

            let displayName = ""; 
            let adminComment = ""; 
            let withcomments = ""; 
            let explanation = "";
            let isShowNextBtn = false;
            await axios.post(requestDomain +"/rest/anonymous/consentapplicant/status/search",{ phrAlias, phrUserId , orderNumber})
                .then(function (response) {
                    // 同意状況をメモリに保存
                    displayName = response.data.displayName;
                    // 状況メッセージ(申請同意状態:説明)をメモリに保存
                    explanation = response.data.explanation;
                    // 管理者コメントをメモリに保存
                    if(response.data.adminComment){
                        adminComment = response.data.adminComment;
                        withcomments ="#adminCommentModalLong";
                    }
                    // displayNameでボタン切り替える
                    isShowNextBtn = ("未参加" == displayName || "却下" == displayName);
                })
                .catch(function (error) {
                    if(error.response.data.orderNumber){
                        throw new Error(JSON.stringify(error.response.data));
                    }else{
                        throw new Error(error.response);
                    }
            })
            
            // 同意状況をストアに保存
            this.commit("setDisplayName", displayName);
            this.commit("setExplanation", explanation);
            this.commit("setAdminComment", adminComment);
            this.commit("setWithcomments", withcomments);
            this.commit("setIsShowNextBtn", isShowNextBtn);

        }
    }
})
